export const CUENTA_CONTABLE_GRUPO_OPTIONS = (t: $TSMigrationFixMe) => [
  {
    value: null,
    label: `${t("informes.perdidasGanancias.header.allGroupLabel")}`,
  },
  {
    value: 1,
    label: `${t("informes.perdidasGanancias.header.finanBasicLabel")}`,
  },
  {
    value: 2,
    label: `${t("informes.perdidasGanancias.header.nonCurrentAssetsLabel")}`,
  },
  {
    value: 3,
    label: `${t("informes.perdidasGanancias.header.stocksLabel")}`,
  },
  {
    value: 4,
    label: `${t("informes.perdidasGanancias.header.vendorCustomerLabel")}`,
  },
  {
    value: 5,
    label: `${t("informes.perdidasGanancias.header.finanAccountLabel")}`,
  },
  {
    value: 6,
    label: `${t("informes.perdidasGanancias.header.purchasesExpensesLabel")}`,
  },
  {
    value: 7,
    label: `${t("informes.perdidasGanancias.header.salesIncomeLabel")}`,
  },
  {
    value: 8,
    label: `${t("informes.perdidasGanancias.header.gastPatNetLabel")}`,
  },
  {
    value: 9,
    label: `${t("informes.perdidasGanancias.header.ingrPatriNetoLabel")}`,
  },
]

export const TIPO_INFORMES_SUMA_SALDO = (t: $TSMigrationFixMe) => [
  { value: 2, label: `${t("informes.saldos.filter.subGroupLabel")}` },
  { value: 1, label: `${t("informes.saldos.filter.accountLabel")}` },
  { value: 0, label: `${t("informes.saldos.filter.subAccountLabel")}` },
]
